define([
    "./restrictionConfigurationModule",
    "./restrictionConfigurationRouter",
    "./restrictionConfigurationController",
    "./restrictionConfigurationService"
], function () {
});